<template>
  <div class="personalExam">
    <!-- 考试列表 -->
    <div v-if="examList == null">
      <el-empty description="加载中"></el-empty>
    </div>
    <div v-else-if="examList.length == 0">
      <el-empty description="空空如也"></el-empty>
    </div>
    <div class="mock_examlist" v-else>
      <examlistItem :examList="examList" :myexam="myexam"></examlistItem>
    </div>
    <div class="page_pl">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="queryParams.pageNum"
        :page-size="queryParams.pageSize"
        background
        layout="total,prev, pager, next"
        :total="total"
        hide-on-single-page
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { myexamList } from "@/api/mockExamination";
import examlistItem from "@/components/examlist/index.vue";
export default {
  name: "personalExam",
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 5,
      },
      examList: null,
      total: 0,
      myexam: true,
    };
  },
  components: { examlistItem },
  created() {
    this.mocklistall();
  },
  mounted() {},
  methods: {
    //考试列表
    mocklistall() {
      myexamList(this.queryParams).then((res) => {
        this.examList = res.rows;
        this.total = res.total;
      });
    },
    //分页
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.mocklistall();
      this.toTop();
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.page_pl {
  margin: 30px 0;
  text-align: center;
}
</style>
